"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BACKEND_URL = void 0;
exports.BACKEND_URL = 'https://dev-tool.reclaimprotocol.org';
